const slideUpDown = {
    props: {
        active: false,
        animateOnStart: false
    },
    template: `<div class="slide-up-down" :class="activeClass">
        <slot></slot>
    </div>`,
    data: function () {
        return {
            _this: null,
            isOpen: false
        };
    },
    mounted() {
        this._this = jQuery(this.$el)
        
        this.checkToOpen(this.active, this.animateOnStart)        


        this.$watch(
            () => this.active,
            (newVal, oldVal) => {
                this.$nextTick(()=>{
                    this.checkToOpen(newVal, true)
                })
                
            }
        );
    },
    methods: {
        checkToOpen(active, animated){
            if(active){
                this.openSlide(animated)
            } else{
                this.closeSlide(animated)
            }
        },
        openSlide(animated){
            this.isOpen = true
            if(animated){
                this._this.slideDown()
            } else {
                this._this.show()
            }
        },
        closeSlide(animated){
            this.isOpen = false
            if(animated){
                jQuery(this.$el).slideUp()                    
            } else {
                this._this.hide()
            }
        }
    },
    computed:{
        activeClass(){
            return this.isOpen ? 'active' : ''
        }
    }
};
